import React from "react"
import ManageInvitations from "../../components/ManageInvitations"

const InvitationManager = () => {
  return (
    <div>
      <h1 className="d-flex justify-content-center align-items-center mb-4">
        Gestor de Invitaciones
      </h1>
      <ManageInvitations />
    </div>
  )
}

export default InvitationManager
